var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-button c-button--primary",attrs:{"role":"button","title":("Go to " + _vm.href)},domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm._cta}})}
var staticRenderFns = []

export { render, staticRenderFns }